import React from 'react';
import {
  StyleSheet, View, TouchableOpacity, Alert, Platform,
} from 'react-native';
import Icon from 'react-native-vector-icons/Ionicons';
import { Colors, ProgressBar } from 'react-native-paper';

import { appColors } from '../../assets/styles/global';
import { AppText } from '../form';
import { pixelDimensions } from '../../config/utils';

const ClassItem = ({
  item, navigation, index, progress,
}) => (
  <TouchableOpacity
    onPress={() => {
      if (progress >= 1) {
        if (Platform.OS === 'web') {
          alert('O horário dessa aula já acabou. espere a próxima.');
        } else {
          Alert.alert('Aula expirou!', 'O horário dessa aula já acabou. espere a próxima.');
        }
      } else if (progress <= 0) {
        if (Platform.OS === 'web') {
          alert('Aula ainda não começou!', 'O horário dessa aula ainda não começou. Espere o horário marcado para entrar.');
        } else {
          Alert.alert('Aula ainda não começou!', 'O horário dessa aula ainda não começou. Espere o horário marcado para entrar.');
        }
      } else {
        navigation.navigate('Worker Online Gym Details', { details: { ...item, index } });
      }
    }}
    style={styles.viewListItem}
  >
    <View style={styles.viewListItemTop}>
      <View style={styles.viewFlexCenter}>
        <View style={styles.viewWhiteCircle}>
          <AppText style={[styles.textList, styles.textPurple]}>{1 + index}</AppText>
        </View>
        <AppText style={[styles.textList]}>{item.titulo}</AppText>
      </View>
      <View style={styles.viewFlexCenter}>
        <View style={styles.viewInterval}>
          <AppText style={[styles.textList]}>{`${item.horario_inicio} - ${item.horario_fim}`}</AppText>
        </View>
        <Icon name="chevron-forward-outline" style={styles.iconListForward} />
      </View>
    </View>
    <View style={styles.viewProgress}>
      <ProgressBar progress={progress} color={appColors.primary} />
    </View>
  </TouchableOpacity>
);

const styles = StyleSheet.create({
  iconListForward: {
    color: Colors.white,
    fontSize: pixelDimensions(6),
  },
  textList: {
    color: Colors.white,
    fontSize: pixelDimensions(3.5),
  },
  textPurple: {
    color: appColors.primary,
  },
  viewFlexCenter: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  viewInterval: {
    padding: pixelDimensions(2),
    borderRadius: pixelDimensions(20),
    backgroundColor: Colors.purple900,
  },
  viewListItem: {
    marginHorizontal: pixelDimensions(5),
    marginBottom: pixelDimensions(4),
  },
  viewListItemTop: {
    marginBottom: pixelDimensions(2),
    padding: pixelDimensions(3),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: appColors.primary,
    borderRadius: pixelDimensions(3),
  },
  viewProgress: {
    backgroundColor: Colors.white,
    width: pixelDimensions(70),
  },
  viewWhiteCircle: {
    backgroundColor: Colors.white,
    height: pixelDimensions(7),
    width: pixelDimensions(7),
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 50,
    marginRight: pixelDimensions(2),
  },
});

export default ClassItem;
